export default class UserCacheName {
    static getUserList(): string {
        return "userList";
    }

    
}